<template>
  <v-container grid-list-md>
    <div class="pwc-logo">
      <img src="../../assets/logo.png">
    </div>
    <v-layout class="font-size: 14px;">
      <v-flex xs12 xl6 offset-xl3>
        <v-btn color="blue darken-1" flat @click="goBack">返回列表</v-btn>
        <v-card>
          <v-img v-if="!videoUrl" :src="video.courseCover" aspect-ratio="1.7" />
          <video v-if="videoUrl" ref="video" controls="true" controlslist="nodownload" width="100%" :poster="video.courseCover">
            <source :src="videoUrl">
          </video>
          <v-card-title primary-title>
            <div class="detail-title">
              <h2>{{ video.courseName }}</h2>
              <!-- <div class="video-time">
                <div>{{ video.courseTime }}</div>
              </div> -->
              <div class="video-title">
                <h4>{{ video.teacher }}</h4>
                <h4>{{ video.courseDate }}</h4>
              </div>
            </div>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">系统提示</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field v-model="code" label="请输入密码观看视频" type="password" required @blur="backToTop" />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" flat :disabled="loading.submitBtnLoading" @click="goBack">返回列表</v-btn>
          <v-btn color="blue darken-1" flat :disabled="!code" :loading="loading.submitBtnLoading" @click="submitValidate">提交</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import Actions from '@/constants/action'
import { mapActions, mapState } from 'vuex'
export default {
  data() {
    return {
      dialog: false,
      videoUrl: '',
      code: '',
      validateTimes: {},
      validateVideoUrl: {}
    }
  },
  computed: {
    ...mapState(['video', 'loading'])
  },
  mounted() {
    const courseId = this.video.courseId
    const jiange = 1000 * 60 * 60 * 8
    const times = localStorage.getItem('_lastValidateTime_') || '{}'
    const validateVideoUrl = localStorage.getItem('_validateVideoUrl_') || '{}'
    this.validateTimes = JSON.parse(times)
    this.validateVideoUrl = JSON.parse(validateVideoUrl)
    const nowTime = new Date().getTime()
    if (courseId && this.validateTimes[courseId]) {
      if (nowTime - this.validateTimes[courseId] < jiange) {
        this.dialog = false
        this.videoUrl = this.validateVideoUrl[courseId]
        this.forbid()
      } else {
        this.dialog = true
      }
    } else {
      this.dialog = true
    }
  },
  methods: {
    ...mapActions({
      validateCode: Actions.VALIDATE_VIDEO_CODE
    }),
    async submitValidate() {
      const res = await this.validateCode({
        wathchCode: this.code,
        courseId: this.video.courseId
      })
      if (res.resultCode === '0') {
        this.dialog = false
        this.videoUrl = res.coursePath
        const nowTime = new Date().getTime()
        const newValidate = {}
        const newVideoUrl = {}
        newValidate[this.video.courseId] = nowTime
        newVideoUrl[this.video.courseId] = this.videoUrl
        localStorage.setItem('_lastValidateTime_', JSON.stringify(Object.assign(this.validateTimes, newValidate)))
        localStorage.setItem('_validateVideoUrl_', JSON.stringify(Object.assign(this.validateVideoUrl, newVideoUrl)))
        this.forbid()
      }
    },
    forbid() {
      this.$nextTick(() => {
        if (this.$refs['video']) {
          this.$refs['video'].oncontextmenu = () => {
            return false
          }
          this.$refs['video'].onerror = () => {
            this.dialog = true
          }
        }
      })
    },
    backToTop() {
      window.scroll(0, 0)
    },
    goBack() {
      history.back(-1)
    }
  }
}
</script>

<style lang="scss">
.pwc-logo {
  margin: auto;
  box-sizing: border-box;
  position: relative;
  height: auto;
  width: auto;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  max-width: 640px;
  padding-top: 36px;
  margin-bottom: 20px;
  img {
    width: 90%;
  }
}
.detail-title {
  width: 100%;
  h2 {
    font-size: 20px;
  }
  h4 {
    font-size: 14px;
  }
}
.video-title {
  line-height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.video-time {
  display: flex;
  justify-content: flex-end;
  color: rgb(208, 74, 2);
  font-size: 16px;
  font-weight: 800;
}
video::-internal-media-controls-download-button {
    display:none;
}
video::-webkit-media-controls-enclosure {
    overflow:hidden;
}
video::-webkit-media-controls-panel {
    width: calc(100% + 30px);
}
</style>
